import { jsx as _jsx } from "react/jsx-runtime";
import { Children } from "react";
import classNames from "classnames";
import { Column } from "./components/Column";
import styles from "./Row.module.scss";
export const Row = ({ children, className, component, dataTestId }) => {
    const Component = component || "div";
    Children.forEach(children, (child) => {
        if (!child) {
            return;
        }
        const isColumnElement = typeof child === "object" && "type" in child && child.type === Column;
        if (!isColumnElement) {
            throw new Error("Row component only accepts Column components as children");
        }
    });
    return (_jsx(Component, { className: classNames(styles.row, className), "data-testid": dataTestId, children: children }));
};
//# sourceMappingURL=Row.js.map